import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, ToggleButton, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonTypography, TopButton, TopButtonTypography } from '../TestroomTemplate';

type Props = { screenSync: boolean; onToggle: () => void };

export const TestroomScreenSync = (props: Props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const enable = !props.screenSync;
    const isScreenSync = props.screenSync;

    return (
        <TopButton>
            <TopButtonTypography>{t('screenSync')}</TopButtonTypography>
            <ButtonTypography
                sx={{
                    padding: '0px 8px',
                }}>
                <Stack direction='row' justifyContent='center' alignItems='center'>
                    <ToggleButton
                        value='check'
                        selected={isScreenSync}
                        onChange={async () => {
                            setOpen(true);
                        }}
                        size='small'
                        sx={{ p: 0 }}>
                        {isScreenSync ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                    </ToggleButton>
                    <Typography>{t('enable')}</Typography>
                </Stack>
            </ButtonTypography>
            <Dialog open={open} onClose={() => setOpen(false)} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
                <DialogTitle id='alert-dialog-title'>
                    {enable ? t('enable') : t('disable')} {t('screenSync')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id='alert-dialog-description'>
                        {enable ? t('enable') : t('disable')} {t('screenSync')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>{t('cancel')}</Button>
                    <Button
                        onClick={() => {
                            props.onToggle();
                            setOpen(false);
                        }}
                        autoFocus>
                        {t('confirm')}
                    </Button>
                </DialogActions>
            </Dialog>
        </TopButton>
    );
};
